export default {"src":"/_next/static/media/heart-filled-black.e5ac8635.svg","height":12,"width":14,"blurWidth":0,"blurHeight":0};